"use client";

import { useContext } from "react";
import { useState } from "react";
import { createContext, ReactNode } from "react";

interface FindARepContextType {
  selectedState?: string;
  setSelectedState: (arg0: string) => void;
}

export const FindARepContext = createContext<FindARepContextType>({
  selectedState: "",
  setSelectedState: () => {},
});

interface FindARepProviderProps {
  children: ReactNode;
}

export const FindARepContextProvider = FindARepContext.Provider;

export function FindARepProvider({ children }: FindARepProviderProps) {
  const [selectedState, setSelectedState] = useState("");

  return (
    <FindARepContextProvider
      value={{
        selectedState,
        setSelectedState,
      }}
    >
      {children}
    </FindARepContextProvider>
  );
}

export function useFindARep() {
  const context = useContext(FindARepContext);
  if (context === undefined) {
    throw new Error("useFindARep must be used within a FindARepProvider");
  }
  return context;
}
